export const dashboards_locale = {
  ADD_DASHBOARD: "Add new dashboard",
  EDIT_DASHBOARD: "Edit dashboard",
  REFRESH: "refresh",
  ADD_WIDGET: "add widget",
  SAVE_DASHBOARD: "save dashboard",
  DELETE_DASHBOARD: "delete dashboard",
  CANCEL: "cancel",
  AVAILABLE_WIDGETS: "Available widgets",
  NO_DASHBOARD_FOUND: "No dashboards could be found.",
  SET_DASHBOARDS_PAGE_AS_DEFAULT: "Set Dashboards page as default",
  SHOW_ONlY_MY_STEPS: "Show only steps from my files",
  YOU_HAVE_NO_ACCESS: "You have no access to see this data",
  MODALS: {
    SET_DASHBOARD_NAME_TITLE: 'Dashboard name',
    SET_DASHBOARD_NAME: 'Choose a dashboard name',
    DELETE_DASHBOARD_TITLE: "Delete dashboard",
    DELETE_DASHBOARD: "Are you sure you want to delete this dashboard?",
    CANCEL_CONFIRMATION_TITLE: "Cancel dashboard changes",
    CANCEL_CONFIRMATION: "Are you sure you want to cancel unsaved changes?",
  },
  WIDGETS: {
    OPERATIONAL_FILES: {
      FILE_NUMBER: "Operational file nr.",
      FILE_TYPE: "File type",
      STEPS: "Steps",
      STEPS_TEXT: "Completed steps / Total steps",
    },
    OPERATIONAL_FILE_STEPS: {
      FILE_NUMBER: "Operational file nr.",
      DESCRIPTION: "Description",
      EXPIRATION_DATE: "Expiration date",
      STEP_ACTIVE: "Active",
      STEP_EXPIRED: "Expired",
      STEP_EXPIRE_TOMORROW: "Expire tomorrow",
      STEP_EXPIRE_TODAY: "Expire today",
      STEP_NO_EXPIRATION: "No expiration date",
    },
    QUOTE_FILES: {
      FILE_NUMBER: "Accounting number",
      FILE_TYPE: "File type",
      DEADLINE: "Deadline",
      DEADLINE_REACHED: "Deadline reached",
      DEADLINE_TOMORROW: "Deadline tomorrow",
      DEADLINE_TODAY: "Deadline today",
      NO_DEADLINE: "No deadline specified",
      ACTIVE: "Active",
    },
    EXPIRED_OUTGOING_INVOICES: {
      TYPE: "Type",
      INVOICE_NUMBER: "Invoice number",
      INVOICE_DATE: "Invoice date",
      INVOICE_EXPIRATION_DATE: "Invoice expiration date",
      CUSTOMER_NAME: "Customer name"
    }
  }
};
